<div class="row">
    <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3">
        <h2>User Visits</h2>
    </div>
    <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3">
        <input class="input-container" [nbDatepicker]="rangepicker" nbInput [(ngModel)]="date" placeholder="Search Date"
            autocomplete="off" />
        <button *ngIf="this.endDate" class="delete-button" type="reset" (click)="clearDate()">
            <i class="fas fa-times"></i>
        </button>
        <nb-rangepicker #rangepicker [range]="date" (rangeChange)="updateRangeDate($event)" format="yyyy-MM-DD"></nb-rangepicker>
    </div>
    <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3">
        <input style=" background-color: white;" type="text" placeholder="Search Text" nbInput [(ngModel)]="word"
            (keyup)="onFilterKeySearch()" />
    </div>
    <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3" *ngIf="role=='admin'">
        <ng-select placeholder="Search Store" [(ngModel)]="storeId" (change)="onStoreSelection()">
            <ng-option *ngFor="let data of storeList" [value]="data?._id">
                {{data?.storeName}}
            </ng-option>
        </ng-select>

    </div>
    <div class="col-sm-6 col-md-4 col-lg-4 col-xl-3 " *ngIf="role=='manager'">
        <ng-select placeholder="Search Store" [(ngModel)]="storeId" (change)="onStoreSelection()">
            <ng-option *ngFor="let data of storeList" [value]="data?._id">
                {{data?.storeName}}
            </ng-option>
        </ng-select>

    </div>
</div>
<div class="col-sm-12" style="margin-top: 20px">
    <nb-card>
        <nb-card-body>
            <table class="table text-center">
                <thead>
                    <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">User</th>
                        <th scope="col">Store</th>
                        <th scope="col">Time</th>
                        <th scope="col">Access Method</th>
                    </tr>
                </thead>
                <tbody *ngIf="role=='manager'">
                    <tr
                        *ngFor=" let data of userVisitData | paginate: { itemsPerPage: 10, currentPage: page, totalItems: total };let i = index">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{ data.userData.name }}</td>
                        <td>{{ data.storeData.storeName }}</td>
                        <td>{{ data.visitTime | date : "dd/MM-YYYY HH:mm" }}</td>
                        <td>{{ data.accessMethod }}</td>
                    </tr>
                </tbody>

                <tbody *ngIf="role=='admin'">
                    <tr *ngFor="
              let data of userVisitData | paginate: { itemsPerPage: 10, currentPage: page, totalItems:total };let i = index"
                        (click)="onUserSelect(data)" style="cursor: pointer;">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{ data.userData.name }}</td>
                        <td>{{ data.storeData.storeName }}</td>
                        <td>{{ data.visitTime | date : "dd/MM-YYYY HH:mm" }}</td>
                        <td>{{ data.accessMethod }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination-controls class="pagination" [responsive]="true" (pageChange)="pageChanged($event)"
                previousLabel="Prev" nextLabel="Next"></pagination-controls>
        </nb-card-body>
    </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>